export const myCustomTheme = {
  // ----------------------------------------------------
  // COLORS
  // ----------------------------------------------------
  colors: {
    // Main Backgrounds
    bg_primary: "#ffffff",        // soft beige background
    bg_secondary: "#ebebeb",      // darker warm beige
    // bg_primary: "#D9D2C3",        // soft beige background
    // bg_secondary: "#B8AA96",      // darker warm beige

    // Typography
    // heading: "#2F3136",          // dark charcoal heading
    heading: "#000f33",          // dark charcoal heading
    p_text: "#F4EFE6",            // soft light paragraph text

    // Highlight / Accent
    high_light: "#CBB79C",        // warm cream accent

    // Navbar
    menu_text: "#7A746B",         // muted gray-brown
    menu_hover: "#2F3136",        // dark hover effect

    // Buttons
    button_text: "#FFFFFF",
    button_bg: "#000f33",         // dark button
    // button_bg: "#2F3136",         // dark button
    button_hover: "#4A4D52",      // softer hover shade

    // Icons
    icon_color: "#5F5A52",
    icon_border: "rgba(255, 248, 235, 0.7)",

    // Header/Footer
    header_footer_bg: "#ffffff",
  },

  // ----------------------------------------------------
  // SHADOWS
  // ----------------------------------------------------
  shadows: {
    // Soft futuristic neumorphism
    neumorphic:
      "rgba(255,255,255,0.45) -6px -6px 14px, rgba(0,0,0,0.18) 6px 6px 18px, rgba(255,255,255,0.25) -3px -3px 8px inset, rgba(0,0,0,0.08) 3px 3px 8px inset",

    // Soft Shadow
    soft: "0px 4px 18px rgba(0,0,0,0.12)",

    // Strong Shadow
    hard: "0px 8px 30px rgba(0,0,0,0.28)",

    // Icon Box Shadow
    icon_box:
      "rgba(255,255,255,0.18) -2px -2px 8px inset, rgba(0,0,0,0.18) 2px 2px 10px",
  },

  // ----------------------------------------------------
  // TYPOGRAPHY
  // ----------------------------------------------------
  typography: {
    heading_font: "'Jost', sans-serif",
    text_font: "'Nunito', sans-serif",

    menu_size: "1.1rem",
    icon_size: "1.2rem",
  },

  // ----------------------------------------------------
  // SPACING
  // ----------------------------------------------------
  spacing: {
    navbar_padding: "0.6rem 3rem",
    menu_gap: "2rem",
    social_gap: "1rem",

    icon_size: "42px",
    border_radius: "10px",

    container_max: "1440px",
  },

  // ----------------------------------------------------
  // MEDIA
  // ----------------------------------------------------
  media: {
    mobile: "768px",
    tab: "1024px",
  },
};